export const o2Domains = {
  staging: '.o2-tv.cz',
  production: '.o2tv.cz',
};
